import {
  useState,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import API from "../../services/api";

function AddCategory() {

  const navigate =
    useNavigate();

  const [name,
    setName] =
    useState("");

  const submit =
    async (e) => {

      e.preventDefault();

      try {

        const token =
          localStorage.getItem(
            "adminToken"
          );

        await API.post(
          "/categories",
          { name },
          {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          }
        );

        navigate(
          "/admin/categories"
        );

      } catch (err) {
        console.log(err);
      }

    };

  return (
    <div>

      <h1
        className="
        text-3xl
        font-bold
        mb-6
      "
      >
        Add Category
      </h1>

      <form
        onSubmit={submit}
        className="
        bg-[#111]
        p-6
        rounded-2xl
        max-w-xl
      "
      >

        <input
          value={name}
          onChange={(e) =>
            setName(
              e.target.value
            )
          }
          placeholder="Category Name"
          required
          className="
          w-full
          p-3
          rounded-xl
          bg-black
          mb-4
        "
        />

        <button
          className="
          px-5
          py-3
          bg-yellow-500
          text-black
          rounded-xl
          font-semibold
        "
        >
          Save Category
        </button>

      </form>

    </div>
  );
}

export default AddCategory;